// extracted by mini-css-extract-plugin
export default {"Tr":"ArticlesTable_Tr__1L8ms","ColumnFilter":"ArticlesTable_ColumnFilter__pgJxy"};